import {Navigate,useParams} from 'react-router';
import {withBuildingScope} from '../ui/building-scope';
/** Preserve old bookmarks; premises creation now belongs to ordinary onboarding. */
export function ProvisionalProperties(){const {id=''}=useParams();return <Navigate replace to={withBuildingScope(`/buildings/${id}/mobilisation/premises`,id)}/>;}
